document.addEventListener("DOMContentLoaded", function () {

    /* ------------------------------------------------------------------
       Transformation des liens YouTube en lecteurs intégrés.

       29/07/2026 — réécrit pour accepter les Shorts.
       L'ancienne version cherchait "v=" dans l'adresse : les URL de type
       /shorts/ID n'en contiennent pas, la fonction renvoyait undefined
       puis plantait à la ligne suivante. Elle gère désormais les quatre
       formats, et affiche les Shorts au format vertical.
    ------------------------------------------------------------------ */

    function analyserLienYouTube(url) {
        if (!url) return null;
        var m;

        // Short : youtube.com/shorts/ID
        m = url.match(/youtube\.com\/shorts\/([A-Za-z0-9_-]{6,})/);
        if (m) return { id: m[1], vertical: true };

        // Format court : youtu.be/ID
        m = url.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/);
        if (m) return { id: m[1], vertical: false };

        // Format classique : youtube.com/watch?v=ID
        m = url.match(/[?&]v=([A-Za-z0-9_-]{6,})/);
        if (m) return { id: m[1], vertical: false };

        // Déjà une adresse d'intégration
        m = url.match(/youtube\.com\/embed\/([A-Za-z0-9_-]{6,})/);
        if (m) return { id: m[1], vertical: false };

        return null;
    }

    function creerLecteur(video) {
        var cadre = document.createElement("div");
        cadre.className = video.vertical ? "mm-yt mm-yt--vertical" : "mm-yt";
        cadre.style.cssText =
            "position:relative;width:100%;margin:26px auto;overflow:hidden;" +
            "border-radius:14px;background:#000;" +
            (video.vertical
                ? "max-width:320px;aspect-ratio:9/16;"
                : "max-width:720px;aspect-ratio:16/9;");

        var iframe = document.createElement("iframe");
        iframe.src = "https://www.youtube.com/embed/" + video.id;
        iframe.title = "Vidéo Croissy Fruits";
        iframe.loading = "lazy";
        iframe.allow = "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("frameborder", "0");
        iframe.style.cssText = "position:absolute;inset:0;width:100%;height:100%;border:0;";

        cadre.appendChild(iframe);
        return cadre;
    }

    var zone = document.querySelector(".mm-main-article-blog-info");
    if (!zone) return;

    zone.querySelectorAll("a").forEach(function (lien) {
        var video = analyserLienYouTube(lien.href);
        if (!video) return;

        var paragraphe = lien.parentNode;

        // On ne remplace que si le lien est SEUL sur sa ligne.
        // Un lien YouTube au milieu d'une phrase reste un lien cliquable.
        if (
            paragraphe &&
            paragraphe.tagName === "P" &&
            paragraphe.textContent.trim() === lien.textContent.trim()
        ) {
            paragraphe.parentNode.replaceChild(creerLecteur(video), paragraphe);
        }
    });
});